import {
  CloudDownload,
  CloudDownloadOutlined,
  RefreshOutlined,
  RemoveRedEyeOutlined,
} from "@material-ui/icons";
import {
  Box,
  CardHeader,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  TextField,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { frFR } from "@mui/x-data-grid/locales";
import { useCallback, useEffect, useState } from "react";
import { Route, useNavigate } from "react-router-dom";
import useToast from "../../../../hooks/useToast";
import useConfirm from "../../../../hooks/useConfirm";
import SearchIcon from "@mui/icons-material/Search";
import { RecrutementService } from "../../../../service/admin_service/RecrutementService";
import { DownloadOutlined } from "@mui/icons-material";
import { TYPE_NOTIFICATION } from "../../shares/NotificationBull";
import { exportMultipleSheetsToExcelJS } from "../../../../Helpers/ExcelJsHelper";
import VerticalAlignBottomOutlinedIcon from "@mui/icons-material/VerticalAlignBottomOutlined";
import { AMIService } from "../../../../service/AMI/AMIService";
import { useToastStore } from "../../../../stores/toastStore";

const AssociationsOffreList = ({
  selection = false,
  id_type,
  handleSelectedCV,
}) => {
  const showToastStore = useToastStore((state) => state.showToast);
  const [offres, setOffres] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const navigate = useNavigate();
  const [dataLoading, setDataLoading] = useState(false);
  const [idsButtonLoading, setIdsButtonLoading] = useState([]);
  const { Toast, showToast } = useToast();
  const { DialogComponent, openConfirmDialog } = useConfirm();

  const handleShowCandidatList = (id) => {
    navigate(`volontariat?offre_id=${id}`);
  };
  const handleFetchVolontariatOffreList = () => {
    setDataLoading(true);
    RecrutementService.getOffreVolontariatList({})
      .then((res) => {
        if (res && res.data) {
          setOffres(res.data);
          setFilteredRows(res.data);
        } else {
          setOffres([]);
          setFilteredRows([]);
        }
      })
      .finally(() => {
        setDataLoading(false);
      });
  };

  const handleFilter = (filtre) => {
    if (!filtre || String(filtre).trim() === "") {
      setFilteredRows(offres);
      return;
    }
    const mots = filtre
      .toLowerCase()
      .split(" ")
      .filter((mot) => mot.trim() !== "");
    setFilteredRows(
      offres.filter((item) =>
        mots.every((mot) =>
          Object.values(item).some(
            (val) => val && val.toString().toLowerCase().includes(mot),
          ),
        ),
      ),
    );
  };

  const handleDownloadPj = (id_type, newFileName = "Documents_AMI") => {
    setIdsButtonLoading((prev) => [...prev, "zip_export" + id_type]);
    showToast(
      TYPE_NOTIFICATION.INFO,
      "Téléchargement en cours...<br/><a href='" +
        process.env.REACT_APP_API_BASE_URL +
        "/volontariat/Ami/telecharger_tout_zip?id_type=" +
        id_type +
        "' target='_blank'>cliquer ici si le telechargement ne demarre pas</a>",
      15000,
    );
    
    AMIService.downloadAllPj({ id_type: id_type })
      .then((response) => {
        if (response.status === 200) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          console.log(response.headers);
          const fileName =
            response.headers["Content-Disposition"]
              ?.split("filename=")[1]
              ?.replace(/['"]/g, "") || newFileName + ".zip";
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
        } else {
          showToast(TYPE_NOTIFICATION.ERROR, "Aucun fichier à télécharger");
        }
      })
      .finally(() => {
        setIdsButtonLoading((prev) =>
          prev.filter((id) => id !== "zip_export" + id_type),
        );
      })
      .catch((error) => {
        showToast(TYPE_NOTIFICATION.ERROR, "Erreur de téléchargement.");
      });

    /*  const url = process.env.REACT_APP_API_BASE_URL + '/volontariat/Ami/telecharger_tout_zip?id_type=' + id_type;
    window.open(url, '_blank'); */
  };

  const handleDownloadExcelExperiencesAndReponses = useCallback(
    (id_type, titre = null) => {
      setIdsButtonLoading((prev) => [...prev, "excel_export_exp" + id_type]);
      AMIService.getExperiencesAndReponsesList({ id_type: id_type })
        .then((res) => {
          if (res) {
            if (res && res.data) {
              exportMultipleSheetsToExcelJS(
                res.data,
                titre || "Résumé des réponses par AMI",
              );
            } else {
              showToast(TYPE_NOTIFICATION.ERROR, res.message);
            }
          }
        })
        .finally(() => {
          setIdsButtonLoading((prev) =>
            prev.filter((id) => id !== "excel_export_exp" + id_type),
          );
        });
    },
    [id_type],
  );

  const table_colonne = [
    {
      field: "description",
      headerName: "Réference",
      flex: 0.8,
      minWidth: 120,
    },
    {
      field: "libelle_type",
      headerName: "Titre",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "date_debut_publication",
      headerName: "Date de création",
      flex: 0.5,
      minWidth: 150,
    },
    {
      field: "date_fin_publication",
      headerName: "Date de cloture",
      flex: 0.5,
      minWidth: 150,
    },
    {
      field: "nbr",
      headerName: "Postulant",
      flex: 0.8,
      minWidth: 120,
    },
    {
      field: "action",
      headerName: "Actions",
      minWidth: 180,
      renderCell: (params) => {
        return (
          <Grid>
            <IconButton
              title="Afficher les postulants"
              color="primary"
              onClick={(e) => handleShowCandidatList(params.row.id_type)}
            >
              <RemoveRedEyeOutlined />
            </IconButton>
            <IconButton
              loading={idsButtonLoading.includes(
                "excel_export_exp" + params.row.id_type,
              )}
              title="Exporter en excel les reponses aux formulaires sur l'offre selectionnées"
              color="primary"
              onClick={(e) =>
                handleDownloadExcelExperiencesAndReponses(
                  params.row.id_type,
                  params.row.libelle_type,
                )
              }
            >
              <VerticalAlignBottomOutlinedIcon />
            </IconButton>
            <IconButton
              title="Télécharger les pieces jointes et attestation de bonne fin envoyés"
              color="primary"
              onClick={(e) =>
                handleDownloadPj(params.row.id_type, params.row.libelle_type)
              }
              loading={idsButtonLoading.includes(
                "zip_export" + params.row.id_type,
              )}
            >
              <CloudDownloadOutlined />
            </IconButton>
          </Grid>
        );
      },
    },
  ];

  useEffect(() => {
    handleFetchVolontariatOffreList();
  }, []);

  return (
    <>
      <DialogComponent />
      <Toast />
      <Grid width={"100%"}>
        <Paper elevation={0}>
          <Grid>
            <CardHeader
              title="Offre de volontariat"
              action={
                <Grid container spacing={1}>
                  <Grid item>
                    <TextField
                      id="recherche"
                      fullWidth
                      size="small"
                      onChange={(e) => handleFilter(e.target.value)}
                      placeholder="Recherche"
                      InputProps={{
                        endAdornment: (
                          <IconButton>
                            <SearchIcon />
                          </IconButton>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <IconButton
                      color="primary"
                      onClick={handleFetchVolontariatOffreList}
                    >
                      <RefreshOutlined />
                    </IconButton>
                  </Grid>
                </Grid>
              }
            />
            <Grid container>
              <Box display={dataLoading ? "" : "none"} sx={{ width: "100%" }}>
                <LinearProgress />
              </Box>
              <DataGrid
                sx={{
                  width: {
                    xs: "75.5vw",
                    sm: "90vw",
                    md: "93.5vw",
                    lg: "79.5vw",
                    height: "60vh",
                  },
                }}
                columns={table_colonne}
                rows={filteredRows}
                getRowId={(row) => row.id_type}
                localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </>
  );
};

export default AssociationsOffreList;
